import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  ACCESS_STATUS,
  LIC_AGREMENT_LEBELS,
  URLS,
  HTTP_STATUS_CODE,
  ERROR_MSG,
} from "../../../helper/constants";
import { GeoCheck } from "../GeoCheck/GeoCheck";
import "./LicAgreementPopup.scss";
import Loader from "../../common/Loader/Loader";
import axios from "axios";
import fileDownload from "js-file-download";
import ErrorModal from "../../common/ErrorModal/ErrorModal";
 
const pdfFile = "/lic_agreement/Honeywell-Aerospace-Material-License-Agreement.pdf";
const pdfWorkerFile = "/pdfjs-dist@4.8.69/pdfjs-dist/build/pdf.worker.min.mjs";
const pdfModulePath = ["", "pdfjs-dist@4.8.69", "pdfjs-dist", "build", "pdf.mjs"].join("/");
const loadPdfJsModule = () =>
  new Function("modulePath", "return import(modulePath)")(
    pdfModulePath
  ) as Promise<any>;
 
export const LicAgreementPopup = () => {
  const [show, setShow] = useState(true);
  const [setgeo, setGeo] = useState(0);
  const { t } = useTranslation();
  const [displaypage, setDisplayPage] = useState(true);
  const [errMSg, setErrMsg] = useState("");
  const [scrolldown, setScrollDown] = useState(false);
  const [errMSG, setErorState] = useState({ falg: false, msg: "" });
  const [isPdfLoading, setIsPdfLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const pdfContainerRef = useRef<HTMLDivElement | null>(null);
 
  const { tokenValid, isLoadingToken } = useSelector(
    (state: any) => state.config
  );
  const configData = useSelector(
    (state: any) => state.config?.configData || {}
  );
  const { location, resLocationStatus, isLoadingLocation } = useSelector(
    (state: any) => state.location
  );
  const { licdata, isLoadingLic, resLicStatus } = useSelector(
    (state: any) => state.licagreement
  );
  const approvedStatus = ACCESS_STATUS.APPROVED;
  const checkStatus = tokenValid?.isSuccess;
  const toolAccess =
    checkStatus === true ? tokenValid?.result?.KEY_TOOL_ACCESS : "";
 
  useEffect(() => {
    if (
      tokenValid &&
      isLoadingToken === false &&
      checkStatus === true &&
      toolAccess != "" &&
      toolAccess == approvedStatus
    ) {
      setTimeout(function () {
        setShow(true);
      }, 10);
    }
  }, []);
 
  useEffect(() => {
    let cancelled = false;
 
    const renderPdf = async () => {
      if (!pdfContainerRef.current) {
        return;
      }
 
      setIsPdfLoading(true);
      pdfContainerRef.current.innerHTML = "";
 
      try {
        const pdfjs = await loadPdfJsModule();
 
        if (cancelled) {
          return;
        }
 
        pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerFile;
 
        const loadingTask = pdfjs.getDocument(pdfFile);
        const pdfDocument = await loadingTask.promise;
 
        if (cancelled || !pdfContainerRef.current) {
          return;
        }
 
        const containerWidth = Math.min(
          pdfContainerRef.current.clientWidth || 760,
          760
        );
 
        for (let pageIndex = 1; pageIndex <= pdfDocument.numPages; pageIndex += 1) {
          const page = await pdfDocument.getPage(pageIndex);
          const baseViewport = page.getViewport({ scale: 1 });
          const scale = containerWidth / baseViewport.width;
          const viewport = page.getViewport({ scale });
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
 
          if (!context || cancelled || !pdfContainerRef.current) {
            continue;
          }
 
          canvas.className = "lic-agreement-page";
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          pdfContainerRef.current.appendChild(canvas);
 
          await page.render({
            canvasContext: context,
            viewport,
          }).promise;
        }
 
        if (!cancelled) {
          setIsPdfLoading(false);
        }
      } catch (error) {
        if (!cancelled) {
          setIsPdfLoading(false);
          setErorState({ falg: true, msg: t(ERROR_MSG.ERROR_MS) });
        }
      }
    };
 
    renderPdf();
 
    return () => {
      cancelled = true;
    };
  }, [t]);
 
  const handleClose = () => {
    setShow(false);
  //  setGeo(1);
  };

  const disagreeBtnHandler = () => {
    window.location.href =
      configData.TECHPUB_AEM_DETAILS?.AEM_HOST + URLS.HOME_AEROSPACE_URL;
  };
  const downloadAgreement = async () => {
    // setLoader(true);
    await axios({
      url: "/api/v1/lic-agreement/download",
      method: "GET",
      responseType: "arraybuffer",
    }).then((resp: any) => {
      //setLoader(false);
      fileDownload(resp.data, configData.LIC_PDF?.PDF_NAME);
    });
  };

  const acceptLicAgreement = async () => {
    handleClose();
    // setLoader(true);
    try {
      const response = await fetch("/api/v1/lic-agreement/save", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (HTTP_STATUS_CODE.STATUS_200 === response.status) {
        //  setLoader(false);

        //setGeo(1);
      } else {
        setErrMsg("something went wrong");
        setErorState({ falg: true, msg: t(ERROR_MSG.ERROR_MS) });
      }
    } catch (error) {
      setErorState({ falg: true, msg: t(ERROR_MSG.ERROR_MS) });
    }
  };
  const onChange = () => {
    setErorState({ falg: false, msg: "sucsess" });
  };

  const handleScroll = (event) => {
    if (
      Math.round(event.target.scrollHeight) -
        Math.round(event.target.scrollTop) -
        2 <=
      event.target.clientHeight
    ) {
      setScrollDown(true);
    } else {
      setScrollDown(false);
    }
  };
 
  return (
    <>
      {tokenValid &&
        isLoadingToken === false &&
        isLoadingLocation === false &&
        checkStatus === true &&
        toolAccess != "" &&
        toolAccess == approvedStatus &&
        displaypage === true &&
        setgeo === 1 &&
        resLocationStatus === 204 && (
          <>
            <GeoCheck />
          </>
        )}
      <Modal
        className="modal-wrapper licagreementpopup pdf-modal"
        aria-label="lic poppup"
        show={show}
        id="lic_popup"
      >
        <div className="modalbodycontentlic modalbodycontent">
          <Modal.Header>
            <Modal.Title>
              <span className="modaltitle">{t(LIC_AGREMENT_LEBELS.TITLE)}</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="Modal-body-lic" onScroll={handleScroll}>
            <div>
              {isPdfLoading && (
                <div className="pdf-loading">Loading agreement...</div>
              )}
              <div ref={pdfContainerRef} className="lic-agreement-pdf-container" />
              {!isPdfLoading && errMSG.falg && (
                <div className="pdf-loading">
                  Unable to load agreement preview. Please use Download.
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="footercontainerlic footercontainer">
              <div className="geocheckbtns">
                <div className="leftbtn">
                  <button
                    type="button"
                    className="lic-agreement-btn downloadButton downloadbtn"
                    onClick={downloadAgreement}
                  >
                    {t(LIC_AGREMENT_LEBELS.DOWNLOAD)}
                  </button>
                </div>
                <div className="rightbtn">
                  <Button
                    type="button"
                    aria-label="Close Preferences"
                    className="cancelbtn"
                    variant="secondary"
                    onClick={disagreeBtnHandler}
                  >
                    {t(LIC_AGREMENT_LEBELS.DISAGREE)}
                  </Button>
                  {loader ? (
                    <div className="loder-css">
                      <Loader />
                    </div>
                  ) : (
                    <>
                      {scrolldown ? (
                        <Button
                          type="button"
                          aria-label="Close Preferences"
                          className="submitbtn active"
                          variant="primary"
                          onClick={acceptLicAgreement}
                        >
                          {t(LIC_AGREMENT_LEBELS.AGREE)}
                        </Button>
                      ) : (
                        <Button
                          type="button"
                          aria-label="Close Preferences"
                          className="submitbtn"
                          disabled={true}
                        >
                          {t(LIC_AGREMENT_LEBELS.AGREE)}
                        </Button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
      <ErrorModal
        errorMsg={errMSG.msg}
        errorFlag={errMSG.falg}
        onClose={onChange}
      />
      ;
    </>
  );
};
